module.exports = __webpack_public_path__ + "img/bluebg.e8e7a1d3.jpg";